import {} from '@mui/icons-material';
import { useMediaQuery } from '@mui/material';
import { OrderManagementPage } from '../../../components';
import { useParams } from 'react-router-dom';
import { ChecklistDetails } from '../checklists/ChecklistDetails';

export const ChecklistReviewDetail = () => {
  const { purchaseOrderId }: { purchaseOrderId: string } = useParams();
  const isMobile = useMediaQuery('(max-width: 960px)');

  return (
    <OrderManagementPage
      title={`Checklist Review #${purchaseOrderId}`}
      hasNoContentPadding={isMobile}
    >
      <ChecklistDetails queryId={purchaseOrderId} isChecklistReview />
    </OrderManagementPage>
  );
};
